<template>
    <div class="app-body"
         id="view">
        <div class="padding">
            <user-rate></user-rate>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'

    export default {
        data() {
            return {
                auth: auth,
                env: null,
                search_text: null
            }
        },

        computed: {
            isLargeEnough() {
                let valid_sizes = ['xxl', 'xl', 'lg', 'md']
                if (valid_sizes.includes(this.$mq)) {
                    return true
                }
                return false
            }
        },

        beforeCreate() {
            axios.get('/build-info.json')
                .then(res => {
                    this.env = res.data.env
                })
                .catch(err => {
                    console.log(err)
                })
        },

        beforeRouteEnter(to, from, next) {
            auth.check()
                .then((res) => {
                    next()
                })
                .catch((err) => {
                    next({name: 'Login', query: {redirect: to.fullPath}})
                })
        }
    }
</script>
